import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { DealProgressTab } from '@/components/deals/DealProgressTab';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

const DealProgressPage = () => {
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader 
        title="Deal Progress." 
        subtitle="Track and manage your deal progress"
      />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <DealProgressTab />
      </div>
    </Layout>
  );
};

export default DealProgressPage;